module.exports = __webpack_public_path__ + "img/americanexpress.b3efbc3b.svg";